import { createEntityAdapter, createSlice, EntityState, PayloadAction } from "@reduxjs/toolkit";
import { isEqual, keyBy } from "lodash";

import { Graph_QL, DynamicDataObk } from "../..";
import { ReportTemplate } from "../../../Definitions";

export type ReportTemplateItem = DynamicDataObk<ReportTemplate[]>
export type DeleteTemplateItem = DynamicDataObk<Number[]> 

const reportDataAdapter = createEntityAdapter({
  selectId: (item: ReportTemplateItem) => Graph_QL.ObjToString(item.con)
});

const mergePayloadAndState = (state: EntityState<ReportTemplateItem, string>, {con, data}: ReportTemplateItem) => {
  const identifier = Graph_QL.ObjToString(con);
  if (state.entities[identifier]) {
    const existingData = state.entities[identifier].data;
    const dataDictionary = keyBy(state.entities[identifier].data, "templateId")
    data.forEach((entry) => dataDictionary[entry.templateId!] = entry)
    const newPayload = {con, data: Object.values(dataDictionary)}
    if (newPayload.data.length !== existingData.length || !isEqual(existingData, newPayload.data) ) {
      reportDataAdapter.upsertOne(state, newPayload);
    }
  } else { reportDataAdapter.addOne(state, {con, data})}
}

const removeDeletedFromState = (state: EntityState<ReportTemplateItem, string>, {con, data}: DeleteTemplateItem) => {
  const identifier = Graph_QL.ObjToString(con);
  if (state.entities[identifier]) {;
    const newPayload = {con, data: state.entities[identifier].data.filter((template) =>  template.templateId ? !data.includes(template.templateId) : false)}
    reportDataAdapter.upsertOne(state, newPayload);
  }
}
const reportTemplateSlice = createSlice({
  name: "reportTemplates",
    initialState: reportDataAdapter.getInitialState<ReportTemplateItem[]>([]),
      reducers: {
        maintained: (state, {payload}:PayloadAction<ReportTemplateItem>) => {
          mergePayloadAndState(state, payload);
        },
       deleteEntries: (state, {payload}:PayloadAction<DeleteTemplateItem>) => {
        removeDeletedFromState(state, payload)
       } 
    }
})

export const ReportTemplateActions = reportTemplateSlice.actions;
export default reportTemplateSlice.reducer;